export default class DocumentLifecycle {
    constructor (dto) {
        this.id = 0;
        this.description = '';
        this.defFieldCode = '';
        this.type = null;
        this.preservationMonths = '';
        this.contentTypeId = null;
        this.conditionStr = '';
        this.displayConditionStr = '';
        this.fieldsMap = {};

        if (dto) {
            this.id = dto.id;
            this.description = dto.description;
            this.defFieldCode = dto.defFieldCode;
            this.type = dto.type;
            this.preservationMonths = dto.preservationMonths;
            this.contentTypeId = dto.contentTypeID + '';
            this.conditionStr = dto.conditionStr;
            this.displayConditionStr = '';
            this.fieldsMap = dto.nameFieldsByCode;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Description: this.description,
            DefFieldCode: this.defFieldCode,
            Type: this.type,
            PreservationMonths: this.preservationMonths,
            ContentTypeID: this.contentTypeId,
            ConditionStr: this.conditionStr,
        };
    }
}
